export function b64DecodeUnicode(str) {
  // Going backwards: from bytestream, to percent-encoding, to original string.
  return decodeURIComponent(
    atob(str)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      })
      .join(''),
  )
}

export function formData(form) {
  var ret = {}
  for (var p in form) {
    ret[p] = form[p].value
  }
  return ret
}

export function readCookie(name) {
  var nameEQ = name + '='
  var ca = document.cookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) == ' ') c = c.substring(1, c.length)
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length)
  }
  return null
}

export function nl2br (str) {
  if (typeof str === "undefined" || str === null) {
    return "";
  }

  return (str + "").replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, "$1<br>");
}